/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendLeadReferralResponse
 */
export interface SendLeadReferralResponse {
    /**
     * ULID of the sent referral
     * @type {string}
     * @memberof SendLeadReferralResponse
     */
    referral_id: string;
}

/**
 * Check if a given object implements the SendLeadReferralResponse interface.
 */
export function instanceOfSendLeadReferralResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "referral_id" in value;

    return isInstance;
}

export function SendLeadReferralResponseFromJSON(json: any): SendLeadReferralResponse {
    return SendLeadReferralResponseFromJSONTyped(json, false);
}

export function SendLeadReferralResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendLeadReferralResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'referral_id': json['referral_id'],
    };
}

export function SendLeadReferralResponseToJSON(value?: SendLeadReferralResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'referral_id': value.referral_id,
    };
}

